export const CATEGORIES = ['all', 'art', 'biography', 'computers', 'history', 'medical', 'poetry']
export const SORTINGS = ['relevance', 'newest']
export const DEFAULT_START_INDEX = 0
export const DEFAULT_MAX_RESULTS = 32
export const MAX_WORDS_TITLE = 4
export const SERVICE_BLOCKED_TITLE = 'Not available'
export const SERVICE_BLOCKED_DESCRIPTION = 'maksimbell\'s services are not available in your country.'
export const BOOKS_API_URL = 'https://www.googleapis.com/books/v1/volumes'
export const IPDATA_API_URL = 'https://api.ipdata.co/?api-key='
export const BLOCKED_COUNTRIES = ['Belarus', 'France']